module.exports = __webpack_public_path__ + "static/media/mobileConfigIcon.5134d6fc.png";